import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "./components/Layout";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import LeadsPage from "./pages/LeadsPage";
import MeetingsPage from "./pages/MeetingsPage";
import ClientsPage from "./pages/ClientsPage";
import ShootsPage from "./pages/ShootsPage";
import EditingPage from "./pages/EditingPage";
import AdsPage from "./pages/AdsPage";
import ActivityLogsPage from "./pages/ActivityLogsPage";
import SystemSettingsPage from "./pages/SystemSettingsPage";
import ProfilePage from "./pages/ProfilePage";
import TeamPage from "./pages/TeamPage";
import SocialPage from "./pages/SocialPage";
import WorkPage from "./pages/WorkPage";
import ContentCalendarPage from "./pages/ContentCalendarPage";
import ClientReviewPage from "./pages/ClientReviewPage";

import "./App.css";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  return user ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/dashboard" /> : <AuthPage />}
      />
      {/* Public Client Review Link (No login required) */}
      <Route
        path="/review/post/:token"
        element={<ClientReviewPage />}
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <DashboardPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/leads"
        element={
          <PrivateRoute>
            <LeadsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/meetings"
        element={
          <PrivateRoute>
            <MeetingsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/clients"
        element={
          <PrivateRoute>
            <ClientsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/shoots"
        element={
          <PrivateRoute>
            <ShootsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/editing"
        element={
          <PrivateRoute>
            <EditingPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/ads"
        element={
          <PrivateRoute>
            <AdsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/activity"
        element={
          <PrivateRoute>
            <ActivityLogsPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/team"
        element={
          <PrivateRoute>
            <TeamPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <SystemSettingsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/social"
        element={
          <PrivateRoute>
            <SocialPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/work"
        element={
          <PrivateRoute>
            <WorkPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/calendar"
        element={
          <PrivateRoute>
            <ContentCalendarPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route
        path="/roles"
        element={
          <PrivateRoute>
            <TeamPage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
